// WP-1.17 (NT-B, OD-7): infra alert banners — polled so a backup failure raised by the cron
// surfaces without a reload.
import { alertListResponseSchema, type Alert } from '@pfos/shared';
import {
  useMutation,
  useQuery,
  useQueryClient,
  type UseMutationResult,
  type UseQueryResult,
} from '@tanstack/react-query';
import { api } from './api';

export const ALERTS_KEY = ['alerts'] as const;

export function useAlerts(): UseQueryResult<Alert[]> {
  return useQuery({
    queryKey: ALERTS_KEY,
    queryFn: async () => alertListResponseSchema.parse(await api.get('/api/v1/alerts')).alerts,
    refetchInterval: 60_000,
  });
}

export function useDismissAlert(): UseMutationResult<void, Error, string> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      await api.post(`/api/v1/alerts/${id}/dismiss`);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ALERTS_KEY });
    },
  });
}
